import { createFileRoute } from '@tanstack/react-router';
import { AdminCohorts } from './admin.cohorts.index';

export const Route = (createFileRoute as any)('/instructor/cohorts/')({
  component: () => <AdminCohorts basePath="/instructor" />,
});
